import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader, CheckCircle, XCircle } from 'lucide-react';

const Unsubscribe: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    const unsubscribeToken = searchParams.get('token');
    
    if (!unsubscribeToken) {
      setStatus('error');
      setError('Ugyldig lenke. Vennligst sjekk at du har kopiert hele lenken fra e-posten.');
      return;
    }

    const unsubscribe = async () => {
      try {
        const response = await fetch(
          `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/morning-report?token=${unsubscribeToken}`,
          {
            method: 'PUT',
            headers: {
              'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error('Kunne ikke avslutte abonnementet');
        }

        setStatus('success');
      } catch (err) {
        setStatus('error');
        setError(err instanceof Error ? err.message : 'En feil oppstod');
      }
    };

    unsubscribe();
  }, [searchParams]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white dark:bg-dark-card rounded-lg shadow-sm p-8 dark:border dark:border-dark-border">
        {status === 'loading' && (
          <div className="flex flex-col items-center">
            <Loader className="h-8 w-8 text-blue-500 animate-spin mb-4" />
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              Avslutter abonnement...
            </h1>
            <p className="text-gray-600 dark:text-gray-300">
              Vennligst vent mens vi behandler forespørselen din.
            </p>
          </div>
        )}

        {status === 'success' && (
          <div className="flex flex-col items-center">
            <CheckCircle className="h-12 w-12 text-green-500 mb-4" />
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              Abonnement avsluttet
            </h1>
            <p className="text-gray-600 dark:text-gray-300 text-center">
              Du vil ikke lenger motta morgenrapporten. Takk for at du brukte tjenesten!
            </p>
          </div>
        )}

        {status === 'error' && (
          <div className="flex flex-col items-center">
            <XCircle className="h-12 w-12 text-red-500 mb-4" />
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              Noe gikk galt
            </h1>
            <p className="text-gray-600 dark:text-gray-300 text-center">
              {error || 'Kunne ikke avslutte abonnementet. Vennligst prøv igjen senere.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;